export const TAGS = [
  { name: 'game', children: [] },
  { name: 'item', children: [] },
  { name: 'profile', children: [] },
  { name: 'page', children: [] },
  { name: 'news', children: [{ name: 'article' }, { name: 'announcement' }] },
  {
    name: 'competition',
    children: [
      {
        name: 'leaderboard',
      },
      { name: 'tournament' },
    ],
  },
];

export const TAG_CHILDREN_MAP = {
  news: ['article', 'announcement'],
  competition: ['leaderboard', 'tournament'],
};
